// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bce8bc96","239":"d512661a","455":"6c2a9e6d"}[chunkId] + ".chunk.js";
};